module.exports = __webpack_public_path__ + "img/ezybuild_logo.2137f774.webp";